/**
 * Shared form helpers used by Token Plan / Subscription Plan pages.
 *
 * - LabelWithInfo: form-field label with an info (i) tooltip icon.
 * - PlanToggle:    iOS-style toggle switch (matches user-creation popup).
 */

import React from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';

interface LabelWithInfoProps
{
    htmlFor?: string;
    label: string;
    tooltip: string;
    suffix?: React.ReactNode;
}

export function LabelWithInfo(props: LabelWithInfoProps): React.ReactElement
{
    const { htmlFor, label, tooltip, suffix } = props;
    return (
        <div className="sa-plans-label-row">
            <label htmlFor={htmlFor}>{label}</label>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tip-${htmlFor || label}`}>{tooltip}</Tooltip>}
            >
                <span className="sa-plans-info-icon" tabIndex={0} role="img" aria-label="Help">
                    <InfoCircle size={13} />
                </span>
            </OverlayTrigger>
            {suffix}
        </div>
    );
}

interface PlanToggleProps
{
    checked: boolean;
    onChange: (next: boolean) => void;
    disabled?: boolean;
    label?: React.ReactNode;
    id?: string;
}

export function PlanToggle(props: PlanToggleProps): React.ReactElement
{
    const { checked, onChange, disabled, label, id } = props;
    const autoId = React.useId();
    return (
        <Form.Check
            type="switch"
            id={id || autoId}
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.currentTarget.checked)}
            label={label ?? ''}
            className="sa-plans-switch"
        />
    );
}
